import { CartAddEvent } from '@theme/events';

class CartUpsellAdd {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    const addButton = event.target.closest('.complete-your-set-desc-right a');
    if (!addButton) return;

    event.preventDefault();

    const upsellContainer = addButton.closest('[data-upsell]');
    if (!upsellContainer) return;

    const variantId = upsellContainer.dataset.variantId;
    if (!variantId) {
      console.error('[Upsell] Variant ID missing');
      return;
    }

    /**
     * ✅ Read quantity from your quantity-selector-component
     */
    const qtyInput = upsellContainer.querySelector(
      'quantity-selector-component input[ref="quantityInput"]'
    );

    const quantity = qtyInput
      ? Math.max(1, Number(qtyInput.value))
      : 1;

    addButton.classList.add('loading');
    addButton.setAttribute('aria-disabled', 'true');

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      /**
       * ✅ Collect cart drawer section IDs
       */
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];

      cartItemsComponents.forEach((component) => {
        if (component.dataset.sectionId) {
          sectionIds.push(component.dataset.sectionId);
        }
      });

      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
      }

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        throw new Error(result.message || 'Upsell add failed');
      }

      /**
       * 🔔 Notify the cart system
       */
      document.dispatchEvent(
        new CartAddEvent({}, variantId.toString(), {
          source: 'cart-upsell',
          itemCount: quantity,
          sections: result.sections,
        })
      );

    } catch (error) {
      console.error('[Upsell Add Error]', error);
    } finally {
      addButton.classList.remove('loading');
      addButton.removeAttribute('aria-disabled');
    }
  }
}

/**
 * ✅ Initialize once
 */
export default new CartUpsellAdd();
